<panel width="450">
	<h1>{{ 'company.product-plans.create' | translate }}</h1>
	<section>
		<custom-select [label]="'company.product-plans.choose-brand' | translate" [selectList]="brands" [(value)]="brandId" [required]="true" [allowAutoFocus]="false" />
	</section>
	<edit-order-line [orderLine]="orderLine" />
	<section>
		<button confirm (click)="saveProductPlan()" [label]="'general.save' | translate"></button>
	</section>
</panel>

